export const Roles = Object.freeze({
  ROLE_ADMINISTRATOR: 'ROLE_ADMINISTRATOR',
  ROLE_OFFICER: 'ROLE_OFFICER',
  ROLE_ASSET_MANAGER: 'ROLE_ASSET_MANAGER',
  ROLE_INVOICE_CREATOR: 'ROLE_INVOICE_CREATOR',
})